import React, {PropsWithChildren} from "react"
import Button from "../../Button/Button"
import Admonition from "../../Admonitions/Admonition"

interface EditModeContainerProps {
	onCancel: () => void
	isDocumentResubmitted: boolean
	className: string
	formId: string
}

const resubmitRequiredChangesMessage = (
	<p>
		The information shown might not be up-to-date, as this individual has been re-evaluated. Please make sure the
		details below reflect the changes made, or edit them accordingly.
	</p>
)

export function DocumentEditMode({
	children,
	className,
	onCancel,
	isDocumentResubmitted,
	formId,
}: PropsWithChildren<EditModeContainerProps>) {
	return (
		<div className={className}>
			<div className="edit-mode-header-padded">
				<div className="item-flex-start-padded">
					<h3 className="key-value-card-title"> Document Info </h3>
				</div>
				<div className="item-flex-end">
					<div className="edit-mode-header">
						<div className="item-flex-start">
							<Button
								className="mr-3"
								prefixIcon="delete-close-x"
								size="normal"
								theme="danger"
								variant="outline"
								onClick={() => {
									onCancel()
								}}
							>
								<span>Cancel</span>
							</Button>
						</div>
						<div className="item-flex-start">
							<Button
								form={formId}
								type="submit"
								prefixIcon="approve-v-check-validation"
								size="normal"
								theme="success"
								variant="outline"
							>
								<span>Save</span>
							</Button>
						</div>
					</div>
				</div>
			</div>
			{isDocumentResubmitted && <Admonition type="is-danger" message={resubmitRequiredChangesMessage} />}
			<div className="key-value-card with-background">{children}</div>
		</div>
	)
}
